'use client';

import { FC, useContext } from 'react';
import styles from './QuestionnaireAsideTheme.module.css';
import { FirmSettingsContext } from '@/_contexts/FirmSettingsProvider';
import { QuestionnaireAsideThemeProps } from './QuestionnaireAsideTheme.types';

export const QuestionnaireAsideTheme: FC<QuestionnaireAsideThemeProps> = ({
  primary,
  secondary,
}) => {
  const { colorPrimary, colorSecondary } = useContext(FirmSettingsContext);

  const pColor = primary || colorPrimary;
  const sColor = secondary || colorSecondary;

  if (!pColor || !sColor) return null;

  const barStyle: object = {
    background: `linear-gradient(45deg, ${pColor} 50%, ${sColor} 50%)`,
  };

  return (
    <div className={styles.questionnaireAsideTheme} style={barStyle}></div>
  );
};
